class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.boundSetSubmenuPosition = this.setSubmenuPosition.bind(this);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      window.removeEventListener('resize', this.boundSetSubmenuPosition);
      window.removeEventListener('scroll', this.boundSetSubmenuPosition);
      this.content.style.removeProperty('--header-submenu-top');
      this.content.style.removeProperty('--header-submenu-left');
      this.content.style.removeProperty('--header-submenu-min-width');
      return;
    }

    this.setSubmenuPosition();
    window.addEventListener('resize', this.boundSetSubmenuPosition);
    window.addEventListener('scroll', this.boundSetSubmenuPosition, { passive: true });
  }

  setSubmenuPosition() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary || !this.content || !this.header) return;

    const headerRect = this.header.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();
    const gap = 8;

    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(headerRect.bottom)}px`);
    this.content.style.setProperty('--header-submenu-top', `${Math.floor(headerRect.bottom + gap)}px`);
    this.content.style.setProperty('--header-submenu-left', `${Math.floor(summaryRect.left)}px`);
    this.content.style.setProperty('--header-submenu-min-width', `${Math.ceil(summaryRect.width)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
